import { checkResolution } from 'Functions/helpers'
import { disableScroll, enableScroll } from 'Functions/scroll-lock'
import "lightgallery/src/js/lightgallery.js"
import "lightgallery/modules/lg-video"
import "lightgallery/modules/lg-thumbnail"
import "lightgallery/modules/lg-zoom"
import "lightgallery/modules/lg-hash"

function onTriggerClick(event) {
    event.preventDefault();

    const $lightboxHolder = $(`.js-lightbox-holder#${$(this).data('gallery-id')}`);

    if (!$lightboxHolder.length || $(this).data('query') && !checkResolution($(this).data('query'))) {
        return
    }

    if ($(this).data('video')) {
        $lightboxHolder.find('.js-lightbox.is-video').click();
    }
    else {
        $lightboxHolder.find('.js-lightbox:not(.is-video)').eq(this.dataset.index).click();
    }
}

export function initializeLightgallery() {
    const $ = window.jQuery;

    $('.js-lightbox-holder').each((index, lightboxHolder) => {
        if (lightboxHolder.classList.contains('initialized')) {
            return
        }

        const options = {
            hideBarsDelay: 0,
            autoplay: false,
            autoplayControls: false,
            download: false,
            share: false,
            fullScreen: false,
            videoMaxWidth: "1140px",
            iframeMaxWidth: "100%",
            enableDrag: true,
            enableTouch: true,
            zoom: true,
            closable: false,
            thumbnail: typeof $(lightboxHolder).data('thumbnail') !== 'undefined' ? $(lightboxHolder).data('thumbnail') : true,
            thumbWidth: 110,
            thumbContHeight: 170,
            thumbMargin: 20,
            selector: '.js-lightbox',
            exThumbImage: 'data-thumb',
            galleryId: lightboxHolder.id,
            hash: true,
        }

        if (checkResolution('cxs;txs')) {
            options.thumbWidth = 60
            options.thumbContHeight = 80
            options.thumbMargin = 10
        }

        $(lightboxHolder).lightGallery(options);

        $(lightboxHolder).on('onBeforeOpen.lg', (event) => {
            window.onhashchange = () => {}
        });

        $(lightboxHolder).on('onAfterOpen.lg', (event) => {
            disableScroll()

            for (const lightboxThumbEl of document.querySelectorAll('.lg .lg-thumb-item')) {
                if (!lightboxThumbEl.querySelector('img').src.includes('youtube')) {
                    continue
                }

                lightboxThumbEl.classList.add('is-video')
            }
        });

        $(lightboxHolder).on('onBeforeClose.lg', () => {
            enableScroll()
            history.replaceState('', document.title, `${window.location.pathname}${window.location.search}`)
        });

        initializeLightgalleryTriggers();

        lightboxHolder.classList.add('initialized')
    })
}

export function initializeLightgalleryTriggers() {
    $('.js-lightbox-trigger').each((index, lightboxTrigger) => {
        if (lightboxTrigger.classList.contains('initialized')) {
            $(lightboxTrigger).off('click', onTriggerClick);
        }

        $(lightboxTrigger).on('click', onTriggerClick);

        lightboxTrigger.classList.add('initialized')
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initializeLightgallery()
})
